<script lang="ts">
  import Select, { Option } from '@smui/select';
  import '$lib/css/components/select.scss'

  export let qty = 1
  let qtyOptions: Array<Number> = []

  // set qty selector to 100
  for (let i = 1; i < 100; i++) {
    qtyOptions.push(i)
  }
</script>


<div class="u-select qty qty-mobile">
  <Select class="qty" bind:value={qty}>
    {#each qtyOptions as option, i}
      <Option value={option}>{option}</Option>
    {/each}
  </Select>
</div>


<style lang="scss">
  .u-select {
    width: 65px;
  }
</style>
